const CountryNames = {
    'Argentina': 'ar',
    'Armenien': 'am',
    'Australien': 'au',
    'Barbados': 'bb',
    'Belgien': 'be',
    'Belize': 'bz',
    'Bosnien-Hercegovina': 'ba',
    'Brasilien': 'br',
    'Bulgarien': 'bg',
    'Chile': 'cl',
    'Costa Rica': 'cr',
    'Cypern': 'cy',
    'Danmark': 'dk',
    'Dominikanska Republiken': 'do',
    'Estland': 'ee',
    'Etiopien': 'et',
    'Fiji': 'fj',
    'Filippinerna': 'ph',
    'Finland': 'fi',
    'Folkrepubliken Kina': 'cn',
    'Frankrike': 'fr',
    'Georgien': 'ge',
    'Grekland': 'gr',
    'Grenada': 'gd',
    'Guatemala': 'gt',
    'Guernsey': 'gg',
    'Guyana': 'gy',
    'Haiti': 'ht',
    'Indien': 'in',
    'Indonesien': 'id',
    'Irland': 'ie',
    'Island': 'is',
    'Israel': 'il',
    'Italien': 'it',
    'Jamaica': 'jm',
    'Japan': 'jp',
    'Kanada': 'ca',
    'Karibien': '',
    'Kenya': 'ke',
    'Kroatien': 'hr',
    'Kuba': 'cu',
    'Lettland': 'lv',
    'Libanon': 'lb',
    'Litauen': 'lt',
    'Luxemburg': 'lu',
    'Makedonien (F.Y.R.O.M)': '',
    'Marocko': 'ma',
    'Mauritius': '',
    'Mexiko': 'mx',
    'Moldavien': '',
    'Montenegro': 'me',
    'Namibia': 'na',
    'Nederländerna': 'nl',
    'Nicaragua': 'ni',
    'Nigeria': 'ng',
    'Nordmakedonien': 'mk',
    'Norge': 'no',
    'Nya Zeeland': 'nz',
    'Palestina': 'ps',
    'Panama': 'pa',
    'Paraguay': 'py',
    'Peru': 'pe',
    'Polen': 'pl',
    'Portugal': 'pt',
    'Rumänien': 'ro',
    'Ryssland': 'ru',
    'Saint Kitts & Nevis': 'kn',
    'Schweiz': 'ch',
    'Serbien': 'rs',
    'Singapore': 'sg',
    'Slovakien': 'sk',
    'Slovenien': 'si',
    'Spanien': 'es',
    'Storbritannien': 'gb',
    'Sverige': 'se',
    'Sydafrika': 'za',
    'Thailand': 'th',
    'Tjeckien': '',
    'Trinidad': 'tt',
    'Tunisien': 'tn',
    'Turkiet': 'tr',
    'Tyskland': 'de',
    'Ukraina': 'ua',
    'Ungern': 'at',
    'Uruguay': 'uy',
    'USA': 'us',
    'Venezuela': 've',
    'Vietnam': 'vn',
    'Österrike': 'at'
};

module.exports = CountryNames;



// WEBPACK FOOTER //
// ./src/scripts/helpers/countries.js